import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { isObject, isScrollBehaviorSupported, nonFinite, now, original, step } from "./common.js";
export var windowScroll = function windowScroll(options) {
  var _a, _b;

  var originalBoundFunc = original.windowScroll.bind(window);

  if (options.left === undefined && options.top === undefined) {
    return;
  }

  var startX = window.scrollX || window.pageXOffset;
  var startY = window.scrollY || window.pageYOffset;
  var targetX = nonFinite((_a = options.left) !== null && _a !== void 0 ? _a : startX);
  var targetY = nonFinite((_b = options.top) !== null && _b !== void 0 ? _b : startY);

  if (options.behavior !== "smooth") {
    return originalBoundFunc(targetX, targetY);
  }

  var removeEventListener = function removeEventListener() {
    window.removeEventListener("wheel", cancelScroll);
    window.removeEventListener("touchmove", cancelScroll);
  };

  var context = {
    timeStamp: now(),
    duration: options.duration,
    startX: startX,
    startY: startY,
    targetX: targetX,
    targetY: targetY,
    rafId: 0,
    method: originalBoundFunc,
    timingFunc: options.timingFunc,
    callback: removeEventListener
  };

  var cancelScroll = function cancelScroll() {
    cancelAnimationFrame(context.rafId);
    removeEventListener();
  };

  window.addEventListener("wheel", cancelScroll, {
    passive: true,
    once: true
  });
  window.addEventListener("touchmove", cancelScroll, {
    passive: true,
    once: true
  });
  step(context);
};
export var windowScrollPolyfill = function windowScrollPolyfill(animationOptions) {
  if (isScrollBehaviorSupported()) {
    return;
  }

  var originalFunc = original.windowScroll;

  window.scroll = function scroll() {
    if (arguments.length === 1) {
      var scrollOptions = arguments[0];

      if (!isObject(scrollOptions)) {
        throw new TypeError("Failed to execute 'scroll' on 'Window': parameter 1 ('options') is not an object.");
      }

      return windowScroll(_objectSpread({}, scrollOptions, animationOptions));
    }

    return originalFunc.apply(this, arguments);
  };
};